import { Component } from '@angular/core';

/**
 * Science-map icon component declaration, responsible for displaying the icon for science-map in vis-type selection
 */
@Component({
  selector: 'mav-science-map-icon',
  templateUrl: './science-map-icon.component.html',
  styleUrls: ['./science-map-icon.component.scss']
})
export class ScienceMapIconComponent { }
